import React, { useContext } from "react";
import { ThemeContext } from "styled-components";

import { IconMakataContainer, IconElement } from "./styled";
import { TColor } from "../../theme";

export type IconMakataNames =
  | "gitBranch"
  | "lock"
  | "lockUnlocked"
  | "copy"
  | "checkboxChecked"
  | "star"
  | "starOutline"
  | "group"
  | "bell"
  | "pullRequest"
  | "issue"
  | "repo"
  | "sort"
  | "filter"
  | "plusCircled"
  | "closeCircled"
  | "caution"
  | "gitRepoUpload"
  | "heart"
  | "heartOutline"
  | "comment"
  | "commentOutline"
  | "edit"
  | "locationBalloon"
  | "upDown"
  | "building"
  | "share"
  | "chevronUp"
  | "checkmark"
  | "close"
  | "checkCircled"
  | "checkCircledThick"
  | "uncheckCircledThick";

export const ICON_FILE_NAME_MAP: { [key in IconMakataNames]: string } = {
  gitBranch: "git-branch",
  lock: "lock",
  lockUnlocked: "lock-unlocked",
  copy: "copy",
  checkboxChecked: "checkbox-checked",
  star: "star",
  starOutline: "star-outline",
  group: "group",
  bell: "bell",
  pullRequest: "pull-request",
  issue: "issue",
  repo: "repo",
  sort: "sort",
  filter: "filter",
  plusCircled: "plus-circled",
  closeCircled: "close-circled",
  caution: "caution",
  gitRepoUpload: "git-repo-upload",
  heart: "heart",
  comment: "comment",
  commentOutline: "comment-outline",
  edit: "edit",
  heartOutline: "heart-outline",
  locationBalloon: "location-balloon",
  upDown: "up-down",
  building: "building",
  share: "share",
  chevronUp: "chevron-up",
  checkmark: "checkmark",
  close: "close",
  checkCircled: "check-circled",
  checkCircledThick: "check-circled-thick",
  uncheckCircledThick: "uncheck-circled-thick",
};

export interface IconProps {
  name: IconMakataNames;
  color?: TColor | "currentColor" | null;
  isInline?: boolean;
  onClick?: (...args: any[]) => void;
  size?: string;
  margin?: React.CSSProperties["margin"];
  verticalAlign?: React.CSSProperties["verticalAlign"];
  className?: string;
}

const IconMakata: React.FunctionComponent<IconProps> = ({
  name,
  color = "primary",
  isInline,
  onClick,
  size = "24px",
  margin,
  verticalAlign = "baseline",
  className,
}) => {
  const themeContext = useContext(ThemeContext);
  const isInteractive = onClick !== undefined;

  let fillColor: string | undefined = undefined;

  if (color === "currentColor") {
    fillColor = color;
  } else if (color !== null && themeContext) {
    // @ts-ignore
    fillColor = themeContext.colors[color];
  }

  return (
    <IconMakataContainer
      className={className}
      $height={size}
      $margin={margin}
      $verticalAlign={verticalAlign}
      $isInteractive={isInteractive}
      $isInline={isInline}
      onClick={onClick}
    >
      <IconElement
        $name={ICON_FILE_NAME_MAP[name]}
        $color={fillColor}
        $size={size}
      />
    </IconMakataContainer>
  );
};

export default IconMakata;
